import angular from 'angular';

/* Configuration Imports */
import AccessManagementRouteConfig from './access-management.route';
/* Component Imports */
import AccessManagementComponent from './access-management.component';
import AmGroupListComponent from './components/group-list/am-group-list.component';
import AmGroupCreate from './components/group-create/am-group-create.component';
import AmGroupViewComponent from './components/group-view/am-group-view.component';
import AmAssetsComponent from './components/assets-list/am-assets-list.component';
import AmOperatorsComponent from './components/operators-list/am-operators-list.component';
import AmBulkUploadOperatorsComponent from './components/bulk-upload-operators/am-bulk-upload-operators.component';
import AmDashboardComponent from './components/dashboard/am-dashboard.component';
import AmOperatorViewComponent from './components/operator-view/am-operator-view.component';
import AmOperatorCodesComponent from './components/operator-codes/am-operator-codes.component';
import AmOperatorDetailsFormComponent from './components/operator-details-form/am-operator-details-form.component';
import AmGroupDetailsFormComponent from './components/group-details-form/am-group-details-form.component';
import AmOperatorCreateComponent from './components/operator-create/am-operator-create.component';
import AmAssetTableComponent from './components/assets-list-table/am-assets-list-table.component';
import AmAssignmentsComponent from './components/assignments/am-assignments.component';
import AmOperatorsTableComponent from './components/operators-list-table/am-operators-list-table.component';
import AmAssetListClientComponent from './components/asset-list-client/asset-list-client.component';
import AmAssetViewComponent from './components/asset-view/am-asset-view.component';
import AmAssetOperatorsListComponent from './components/asset-operators-list/am-asset-operators-list.component';
import AmOperatorAssetsComponent from './components/operator-assets-list/operator-assets-list.component';

import AddInputComponent from './components/controls/add-input/add-input.component';
import AmSearchInputComponent from './components/controls/search-input/search-input.component';
import AmIpafInputComponent from './components/controls/ipaf-input/ipaf-input.component';

//--- services
import AmStoreService from './core/am-store.service';
import AccessManagementService from './core/access-management.service';
import AmOperatorsService from './core/am-operators.service';
import AmAssetsService from './core/am-assets.service';
import AmGroupsService from './core/am-groups.service';
import AmFilterPaginationService from './core/am-filter-pagination.service';
import AmAssignmentService from './core/am-assignments.service';
/* Module Imports */
import apiModule from '../../api/api.module';

const accessManagementModule = angular.module('app.access-management', [
  //INTERNAL
  apiModule,
  //THIRD PARTY
]);

accessManagementModule
  /* Configurations */
  .config(AccessManagementRouteConfig)
  // --- Services ---
  .service('amStoreService', AmStoreService)
  .service('accessManagementService', AccessManagementService)
  .service('amOperatorsService', AmOperatorsService)
  .service('amAssetsService', AmAssetsService)
  .service('amGroupsService', AmGroupsService)
  .service('amFilterPaginationService', AmFilterPaginationService)
  .service('amAssignmentService', AmAssignmentService)
  /* Controls */
  .component('amAddInput', AddInputComponent)
  .component('amSearchInput', AmSearchInputComponent)
  .component('amIpafInput', AmIpafInputComponent)
  /* components */
  .component('accessManagement', AccessManagementComponent)
  .component('amAssetsList', AmAssetsComponent)
  .component('amOperatorsList', AmOperatorsComponent)
  .component('amGroupList', AmGroupListComponent)
  .component('amGroupView', AmGroupViewComponent)
  .component('amGroupCreate', AmGroupCreate)
  .component('amDashboard', AmDashboardComponent)
  .component('amBulkUploadOperators', AmBulkUploadOperatorsComponent)
  .component('amOperatorView', AmOperatorViewComponent)
  .component('amOperatorCodes', AmOperatorCodesComponent)
  .component('amOperatorDetailsForm', AmOperatorDetailsFormComponent)
  .component('amGroupDetailsForm', AmGroupDetailsFormComponent)
  .component('amOperatorCreate', AmOperatorCreateComponent)
  .component('amAssetTable', AmAssetTableComponent)
  .component('amAssignments', AmAssignmentsComponent)
  .component('amOperatorsTable', AmOperatorsTableComponent)
  .component('amAssetListClient', AmAssetListClientComponent)
  .component('amAssetView', AmAssetViewComponent)
  .component('amAssetOperatorsList', AmAssetOperatorsListComponent)
  .component('amOperatorAssetsList', AmOperatorAssetsComponent);

export default accessManagementModule.name;
